import { render, staticRenderFns } from "./questionBankManage.vue?vue&type=template&id=ba1c7796"
import script from "./questionBankManage.vue?vue&type=script&lang=js"
export * from "./questionBankManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports